import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import classes from './spinnerStyles/index.module.scss';

type SpinnerProps = {
	light?: boolean;
	small?: boolean;
	className?: string;
	dataTestId?: string;
	style?: CSSProperties;
};

export const Spinner: FC<React.PropsWithChildren<SpinnerProps>> = ({ className, light, small, style, dataTestId }) => {
	const componentClasses = classNames(classes.spinner, className, {
		[classes.spinner_small]: small,
	});
	const innerBallClasses = classNames(classes.innerBall, {
		[classes.innerBall_light]: light,
	});

	return (
		<div
			className={componentClasses}
			style={style}
			data-testid={dataTestId}
		>
			<div className={classes.circle}>
				<div className={classes.ball}>
					<div className={innerBallClasses} />
				</div>
				<div className={classes.ball}>
					<div className={innerBallClasses} />
				</div>
				<div className={classes.ball}>
					<div className={innerBallClasses} />
				</div>
				<div className={classes.ball}>
					<div className={innerBallClasses} />
				</div>
				<div className={classes.ball}>
					<div className={innerBallClasses} />
				</div>
			</div>
		</div>
	);
};
